module.exports = __webpack_public_path__ + "img/home-active.aa97fdae.svg";